import { TeammateRole } from '@/types/teammates';
import { BankApplicationAccountType } from '@/types/bankApplications';

export const FILTERS = {
  STATUS: {
    label: 'Status',
    name: 'status',
    options: [
      { label: 'Active', value: '1' },
      { label: 'Inactive', value: '0' },
    ],
  },
  BANK_ACCOUNT_STATUS: {
    label: 'Bank Account Status',
    name: 'bank_account_status',
    options: [
      { label: 'Open', value: '0' },
      { label: 'Closed', value: '1' },
      { label: 'Locked', value: '2' },
    ],
  },
  TEAMMATE_ROLE: {
    label: 'Role',
    name: 'role',
    options: [
      { label: 'Admin', value: TeammateRole.ADMIN.toString() },
      { label: 'Advisor', value: TeammateRole.ADVISOR.toString() },
      { label: 'Support', value: TeammateRole.SUPPORTER.toString() },
    ],
  },
  ACCOUNT_TYPE: {
    label: 'Account Type',
    name: 'account_types',
    options: [
      {
        label: 'Individual - Checking',
        value: BankApplicationAccountType.INDIVIDUAL.toString(),
      },
      {
        label: 'Joint - Checking',
        value: BankApplicationAccountType.JOINT.toString(),
      },
      {
        label: 'Business - Checking',
        value: BankApplicationAccountType.BUSINESS.toString(),
      },
    ],
  },
};
